export const AUTH_USER = "AUTH_USER";
export const AUTH_ERROR = "AUTH_ERROR";
export const DEAUTH = "DEAUTH";
export const DETECT_WARNING_MACHINE = "DETECT_WARNING_MACHINE";
export const SIGNUP = "SIGNUP";
export const SIGNUP_ERR = "SIGNUP_ERR";
export const SET_FB_RESPONSE = "SET_FB_RESPONSE";
export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const CHANGE_PASSWORD_ERR = "CHANGE_PASSWORD_ERR";
export const REQUEST_FORGOT_PASSWORD = "REQUEST_FORGOT_PASSWORD";
export const REQUEST_FORGOT_PASSWORD_ERR = "REQUEST_FORGOT_PASSWORD_ERR";
export const UPDATE_FORGOT_PASSWORD = "UPDATE_FORGOT_PASSWORD";
export const UPDATE_FORGOT_PASSWORD_ERR = "UPDATE_FORGOT_PASSWORD_ERR";
export const INITIATE_SIGNIN = "INITIATE_SIGNIN";
export const SHOW_PDPA_POPUP = "SHOW_PDPA_POPUP";
export const HIDE_PDPA_POPUP = "HIDE_PDPA_POPUP";
export const PDPA_CONSENT_SUCCESS = "PDPA_CONSENT_SUCCESS";
export const PDPA_CONSENT_ERROR = "PDPA_CONSENT_ERROR";
// Item 01b — the email-verification UX.
/** A verification mail has just been sent; show the "check your email" panel. */
export const VERIFICATION_EMAIL_SENT = "VERIFICATION_EMAIL_SENT";
/** The customer dismissed a verification panel or banner for this session. */
export const VERIFICATION_PANEL_DISMISSED = "VERIFICATION_PANEL_DISMISSED";
/** A resend attempt finished: carries `{ pending, error, cooldownSeconds }`. */
export const VERIFICATION_RESEND_STATE = "VERIFICATION_RESEND_STATE";
